import React from 'react';
import { shape, func } from 'prop-types';
import { Heading } from '@americanexpress/dls-react';
import { IconSuccess } from '@americanexpress/dls-icons';
import { MembershipTextBadge } from '@americanexpress/web-react-extensions';
import styles from './AxpBenefitsActivity.scss';
import { decodeHtmlEntities, getEnrollStatus, getEnrollmentStatusForColor } from '../utils/utils';

export default function BenefitCards({
  benefit,
  onBenefitClick,
}) {
  if (!benefit || typeof benefit !== 'object') return null;
  const headingId = `card-heading-${benefit?.sorBenefitId || benefit?.benefitTitle?.replace(/\s+/g, '-')}`;
  const enrollStatus = getEnrollStatus?.(benefit);

  return (
    <div
      id={`container-${headingId}`}
      data-testid={`container-${headingId}`}
      role="button"
      tabIndex={0}
      onClick={onBenefitClick ? () => onBenefitClick(benefit) : undefined}
      onKeyDown={onBenefitClick ? (e) => { if (e.key === 'Enter' || e.key === ' ') onBenefitClick(benefit); } : undefined}
      className="width-full height-full flex flex-item-grow flex-align-center border radius-container"
    >
      <div className="flex flex-item-grow flex-align-center pad-3-tb pad-3-lr">
        <div className="flex flex-column pad-2-tb flex-align-start flex-item-grow">
          <Heading
            id={headingId}
            data-testid={headingId}
            level={3}
            variant="sans-small-bold"
            className="color-text-regular"
          >
            {benefit?.benefitTitle && decodeHtmlEntities(benefit?.benefitTitle)}
          </Heading>
          {enrollStatus && (
            <MembershipTextBadge
              data-testid={`enroll-status-${headingId}`}
              className="pad-1-tb"
              size="small"
              status={getEnrollmentStatusForColor(benefit)}
            >
              {enrollStatus}
            </MembershipTextBadge>
          )}
        </div>
        <div className="flex flex-Column flex-align-center pad-3-l">
          <div className={styles.iconSuccessBorderRing}>
            <IconSuccess
              size="xl"
              color="success"
              titleId={`icon-success-${headingId}`}
              data-testid={`icon-success-${headingId}`}
              isFilled={true}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

BenefitCards.propTypes = {
  onBenefitClick: func,
  benefit: shape({}).isRequired,
};
